export default __webpack_public_path__ + "static/media/Lava-UI-sm.d1992fd1.webp";